import { useLocale, type Locale } from './index';

const OPTIONS: Array<{ locale: Locale; label: string }> = [
  { locale: 'en', label: 'EN' },
  { locale: 'zh', label: '中文' },
];

export function LanguageToggle() {
  const { locale, setLocale } = useLocale();
  return (
    <div
      role="group"
      aria-label="Language / 语言"
      className="flex items-center gap-1"
      style={{
        fontFamily: "'DM Sans', 'PingFang SC', 'Microsoft YaHei', 'Noto Sans CJK SC', system-ui, sans-serif",
        fontSize: '13px',
        fontWeight: 500,
      }}
    >
      {OPTIONS.map((option, i) => (
        <span key={option.locale} className="flex items-center gap-1">
          {i > 0 && <span aria-hidden="true" style={{ color: '#cccccc' }}>|</span>}
          <button
            type="button"
            onClick={() => setLocale(option.locale)}
            aria-pressed={locale === option.locale}
            className="px-1 transition-ui"
            style={{
              color: locale === option.locale ? '#111111' : '#767676',
              fontWeight: locale === option.locale ? 700 : 500,
              background: 'none',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            {option.label}
          </button>
        </span>
      ))}
    </div>
  );
}
